var _path, _circle, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgRoomReplaced = function SvgRoomReplaced(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 31 31",
    role: "presentation",
    "aria-hidden": true,
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h31v31H0z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    fill: "#A2A2A2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5,
    d: "M22.855 15.5a7.355 7.355 0 1 1-14.71 0 7.355 7.355 0 0 1 14.71 0ZM15.5 24.25a8.75 8.75 0 1 0 0-17.5 8.75 8.75 0 0 0 0 17.5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#A2A2A2",
    d: "M16.266 30.503h-1.5L14.76 1.1h1.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#A2A2A2",
    d: "m8.894 28.844-1.294-.76L22.605 2.503l1.294.759z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#A2A2A2",
    d: "m2.88 24.495-.786-1.278L27.71 7.46l.786 1.277z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#A2A2A2",
    d: "M2.163 23.341 1.49 22l26.51-13.264.671 1.341z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#A2A2A2",
    d: "M1.551 22.134 1 20.74 28.433 9.887l.552 1.394z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#fff",
    d: "m9.5 17-2 3-2-3zM21.5 15l2-3 2 3z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgRoomReplaced);
export { ForwardRef as Icon };
export default "img/room_replaced.4ac105f.svg";